import { FilterOperator, logicalOperators } from '@app/constants';
import { momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
export class MongoStageBuilder {
  _sb: string;
  str: MongoStringBuilderExtension;
  filterOperator: FilterOperator;

  constructor() {
    this._sb = '{';
    this.str = new MongoStringBuilderExtension();
    this.filterOperator = new FilterOperator();
  }

  BuildString(): string {
    if (this._sb.length === 1) {
      return '';
    }
    this._sb = this._sb.substring(0, this._sb.length - 1) + '}';
    if (this._sb.includes('&')) {
      this._sb = this._sb.replace(/&/g, encodeURIComponent('&'));
    }
    if (this._sb.includes('#')) {
      this._sb = this._sb.replace(/#/g, encodeURIComponent('#'));
    }
    if (this._sb.includes('%')) {
      this._sb = this._sb.replace(/%/g, encodeURIComponent('%'));
    }
    if (this._sb.includes('<')) {
      this._sb = this._sb.replace(/</g, encodeURIComponent('%'));
    }
    if (this._sb.includes('>')) {
      this._sb = this._sb.replace(/>/g, encodeURIComponent('%'));
    }
    return this._sb;
  }

  BuildCombineQuery(qry: string): string {
    if (qry) return '{' + qry + '}';
    else return '';
  }

  CreateAndClause(quries: string[]): string {
    if (quries.length == 0) return '';

    let added = false;

    let andQry = "'$and':[ ";
    quries.forEach((qry) => {
      if (qry) {
        andQry += qry + ',';
        added = true;
      }
    });

    if (!added) return '';

    andQry += ']';

    return andQry;
  }

  AddIdClause(fieldName: string, idVal: string, prefix: string = '') {
    this._sb = this.str.AppendIdClause(this._sb, fieldName, idVal, prefix);
  }

  AddIntClause(fieldName: string, idVal: number, prefix: string = '') {
    this._sb += `${prefix}${fieldName}: ${idVal},`;
    return this._sb;
  }

  CreateIdClause(fieldName: string, idVal: string, prefix: string = '') {
    return this.str.CreateIdClause(fieldName, idVal, prefix);
  }

  AddSortClause(fieldName: string, asc: boolean) {
    return `{${fieldName}: ${asc ? 1 : -1} }`;
  }

  AppendSortClause(fieldName: string, asc: boolean) {
    return `,${fieldName}: ${asc ? 1 : -1} }`;
  }

  AddQueryString(query: string) {
    this._sb += query;
  }

  ConvertToSankeCase(fieldName: string): string {
    const result = fieldName.replace(/([A-Z])/g, '_$1');
    const finalResult = result.toLowerCase();
    return finalResult[0] === '_' ? finalResult.substring(1) : finalResult;
  }

  ConvertToLower(fieldName: string): string {
    return fieldName.toLowerCase();
  }

  AddSearchWithAlphabetQueryOnSameField(
    fieldName: string,
    value: string,
    alphabetField: string,
    alphabet: string,
    prefix: string = ''
  ) {
    this._sb = this.str.AppendContainsAndStartsWith(
      this._sb,
      fieldName,
      value.replace('%3F', '?'),
      alphabetField,
      alphabet,
      prefix
    );
  }
  AddSearchWithAlphabetQueryOnSameFieldOnSelectedColumns(
    fieldName: any,
    value: string,
    alphabetField: string,
    alphabet: string,
    prefix: string = ''
  ) {
    this._sb = this.str.AppendContainsAndStartsWithOnSelection(
      this._sb,
      fieldName,
      value.replace('%3F', '?'),
      alphabetField,
      alphabet,
      prefix
    );
  }

  AddOrWithAndQuery(fields: string, value: string, alphabet: string) {
    this._sb = this.str.GetOrWithAndQuery(this._sb, fields, value.replace('%3F', '?'), alphabet);
  }
  AddOrQuery(fields: string, value: string) {
    this._sb = this.str.GetOrQuery(this._sb, fields, value.replace('%3F', '?'));
  }
  AddOrWithAndQueryOnSelectedColumns(fields: any, value: string, alphabet: string) {
    this._sb = this.str.GetOrWithAndQueryOnSelectedColumns(this._sb, fields, value.replace('%3F', '?'), alphabet);
  }

  AddOrWithAndQueryWithTypeChecking(fields: any, value: string, alphabet: string) {
    this._sb = this.str.AddOrWithAndQueryWithTypeChecking(this._sb, fields, value, alphabet);
  }
  AddOrWithAndQueryWithTypeCheckingOnColumnSelection(fields: any, value: string, alphabet: string) {
    this._sb = this.str.AddOrWithAndQueryWithTypeCheckingOnSelectedColumns(this._sb, fields, value, alphabet);
  }
  AddSearchQuery(fieldName: string, value: string[], prefix: string = '') {
    this._sb = this.str.AppendContains(
      this._sb,
      this.ConvertToSankeCase(fieldName),
      value,
      prefix,
      undefined,
      undefined,
      true
    );
  }

  AddSearchQueryWithoutConversion(fieldName: string, value: string[], prefix: string = '') {
    this._sb = this.str.AppendContains(this._sb, fieldName, value, prefix);
  }

  AddAlphabetFilterQuery(fieldName: string, value: string[], prefix: string = '') {
    // tslint:disable-next-line:max-line-length
    this._sb = this.str.AppendStartWith(
      this._sb,
      prefix === '' ? this.ConvertToSankeCase(fieldName) : fieldName,
      value,
      prefix
    );
  }

  AddAlphabetFilterQueryWithoutConversion(fieldName: string, value: string[], prefix: string = '') {
    this._sb = this.str.AppendStartWith(this._sb, fieldName, value, prefix);
  }

  AppendGreaterThanEqualToDate(
    fieldName: string,
    value: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    this._sb = this.str.AppendGreaterThanEqualToDate(this._sb, fieldName, value, logicalOperator, prefix, postfix);
  }
  AppendLessThanEqualToDate(
    fieldName: string,
    value: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    this._sb = this.str.AppendLessThanEqualToDate(this._sb, fieldName, value, logicalOperator, prefix, postfix);
  } //AppendEqualToDate
  AppendEqualToDate(
    fieldName: string,
    value: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    this._sb = this.str.AppendEqualToDate(this._sb, fieldName, value, logicalOperator, prefix, postfix);
  }
}

class MongoStringBuilderExtension {
  constructor() {}
  AppendIdClause(_sb: string, fieldName: string, idVal: string, prefix: string = '') {
    _sb += `${prefix}${fieldName}: { '$oid': '${idVal}'},`;
    return _sb;
  }

  CreateIdClause(fieldName: string, idVal: string, prefix: string = '') {
    return `${prefix}${fieldName}: { '$oid': '${idVal}'}`;
  }

  AppendEqual(
    _sb: string,
    fieldName: string,
    val: string[],
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    let value = '';
    val.forEach((item) => {
      value += `/^${this.Parse(item)}/i,`;
    });

    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { '$nin' : [${value}] }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { '$in' : [${value}] }${postfix},`;
    }

    return _sb;
  }

  AppendContains(
    _sb: string,
    fieldName: string,
    val: string[],
    logicalOperator: string,
    prefix: string = '',
    postfix: string = '',
    isText: boolean = false
  ) {
    let value = '';
    val.forEach((item) => {
      if (typeof item === 'string') {
        if (isText === true) {
          //value += '{ $regex: \'' + this.Parse(item) + '\', $options: \'i\' } ,';
          value += `/${this.Parse(item)}/i,`;
        } else {
          //value += '{  $regex: \'^' + this.Parse(item) + '$\', $options: \'i\' } ,';
          value += `/${this.Parse(item)}/i,`;
          if (item && !isNaN(Number(item))) {
            value += '' + item + ',';
          }
        }
      } else {
        value += '' + item + ',';
      }
    });

    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}':  { '$nin' : [${value}] }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}':  { '$in' : [${value}] }${postfix},`;
    }

    return _sb;
  }
  AppendContainsAndStartsWith(
    _sb: string,
    fieldName: string,
    val: string,
    alphabetField: string,
    alphabet: string,
    prefix: string = ''
  ) {
    if (fieldName === alphabetField) {
      if (
        (val !== undefined && val !== null && val !== 'null' && val !== '') ||
        (alphabet !== undefined && alphabet !== null && alphabet !== 'null' && alphabet !== '')
      ) {
        _sb += `'$or': [{ '$and': [`;
        if (val !== undefined && val !== null && val !== 'null' && val !== '') {
          _sb += `{ '${fieldName}': /${this.Parse(val)}/i}`;
        }
        if (alphabet !== undefined && alphabet !== null && alphabet !== 'null' && alphabet !== '') {
          _sb += `,{ '${fieldName}': /^${this.Parse(alphabet)}/i }`;
        }
        _sb += `  ] }] }`;
      }
    }
    return _sb;
  }
  AppendContainsAndStartsWithOnSelection(
    _sb: string,
    fieldName: any,
    val: string,
    alphabetField: string,
    alphabet: string,
    prefix: string = ''
  ) {
    let fieldsArray = fieldName
      .filter((search: any) => search !== undefined && search.value !== undefined)
      .map((search: any) => ({ value: search.value, isChecked: search.isChecked }));
    if (fieldsArray.length > 0 && fieldsArray.map((c: any) => c.isChecked).includes(true)) {
      if (
        (val && val !== undefined && val !== null && val !== 'null') ||
        (alphabet && alphabet !== undefined && alphabet !== null && alphabet !== 'null')
      ) {
        _sb += `'$or': [`;
        fieldsArray.forEach((col: any) => {
          if (col !== undefined && col.isChecked) {
            _sb += `{ '$and' : [`;
            if (val && val !== undefined && val !== null && val !== 'null') {
              if (isNaN(Number(val))) {
                _sb += `{ '${col.value}': /${this.Parse(val)}/i }`;
              } else {
                // if (val && !isNaN(Number(val))
                // && !element.type.includes('string') && !element.type.includes('String')) {

                _sb += `{ '$or' : [`;
                _sb += `{ '${col.value}': ${this.Parse(val)} }`;
                _sb += `, { '${col.value}': /${this.Parse(val)}/i }`;
                _sb += `]},`;
              }
            }
            if (alphabet !== undefined && alphabet !== null && alphabet !== 'null' && alphabet !== '') {
              if (col.value) {
                _sb += `{ '${col.value}': /^${this.Parse(alphabet)}/i }`;
              }
            }
            _sb += `]},`;
          }
        });
        _sb += ` ] `;
      }
    }
    return _sb;
  }
  // AppendContainsAndStartsWith(
  //   _sb: string,
  //   fieldName: string,
  //   val: string,
  //   alphabetField: string,
  //   alphabet: string,
  //   prefix: string = ''
  // ) {
  //   if (fieldName === alphabetField) {
  //     if ((val !== undefined && val !== null && val !== 'null' && val !== '') ||
  //       (alphabet !== undefined && alphabet !== null && alphabet !== 'null' && alphabet !== '')) {
  //       _sb += `'$or': [{ '$and': [`;
  //       if (val !== undefined && val !== null && val !== 'null' && val !== '') {
  //         _sb += `{ '${fieldName}':{ $regex: '${this.Parse(
  //           val
  //         )}', $options: 'i' }}`;
  //       }
  //       if (
  //         alphabet !== undefined &&
  //         alphabet !== null &&
  //         alphabet !== 'null' &&
  //         alphabet !== ''
  //       ) {
  //         _sb += `,{ '${fieldName}':{ $regex: '^${this.Parse(
  //           alphabet
  //         )}', $options: 'i' }}`;
  //       }
  //       _sb += `  ] }] }`;
  //     }
  //   }
  //   return _sb;
  // }

  AddOrWithAndQueryWithTypeChecking(_sb: string, fields: any, val: string, alphabet: string) {
    if (fields.length > 0) {
      if (
        (val && val !== undefined && val !== null && val !== 'null') ||
        (alphabet && alphabet !== undefined && alphabet !== null && alphabet !== 'null')
      ) {
        _sb += `'$or': [`;
        fields.forEach((element: any) => {
          _sb += `{ '$and' : [`;
          if (val && val !== undefined && val !== null && val !== 'null') {
            if (isNaN(Number(val))) {
              _sb += `{ '${element.field}': /^${this.Parse(val)}/i }`;
            } else {
              // if (val && !isNaN(Number(val))
              // && !element.type.includes('string') && !element.type.includes('String')) {

              _sb += `{ '$or' : [`;
              _sb += `{ '${element.field}': ${this.Parse(val)} }`;
              _sb += `, { '${element.field}': /^${this.Parse(val)}/i }`;
              _sb += `]},`;
            }
          }
          if (alphabet !== undefined && alphabet !== null && alphabet !== 'null' && alphabet !== '') {
            if (element.type.includes('string') || element.type.includes('String')) {
              _sb += `{ '${element.field}': /^${this.Parse(alphabet)}/i }`;
            }
          }
          _sb += `]},`;
        });
        _sb += ` ] `;
      }
    }
    return _sb;
  }
  AddOrWithAndQueryWithTypeCheckingOnSelectedColumns(_sb: string, fields: any, val: string, alphabet: string) {
    let fieldsArray = fields
      .filter((search: any) => search !== undefined && search.field !== undefined)
      .map((search: any) => ({ field: search.field, isChecked: search.isChecked }));
    if (fieldsArray.length > 0 && fieldsArray.map((c: any) => c.isChecked).includes(true)) {
      if (
        (val && val !== undefined && val !== null && val !== 'null') ||
        (alphabet && alphabet !== undefined && alphabet !== null && alphabet !== 'null')
      ) {
        _sb += `'$or': [`;
        fieldsArray.forEach((element: any) => {
          _sb += `{ '$and' : [`;
          if (val && val !== undefined && val !== null && val !== 'null') {
            if (isNaN(Number(val))) {
              _sb += `{ '${element.field}': /${this.Parse(val)}/i }`;
            } else {
              // if (val && !isNaN(Number(val))
              // && !element.type.includes('string') && !element.type.includes('String')) {

              _sb += `{ '$or' : [`;
              _sb += `{ '${element.field}': ${this.Parse(val)} }`;
              _sb += `, { '${element.field}': /^${this.Parse(val)}/i }`;
              _sb += `]},`;
            }
          }
          if (alphabet !== undefined && alphabet !== null && alphabet !== 'null' && alphabet !== '') {
            //if (element.field.includes('string') || element.field.includes('String')) {
            _sb += `{ '${element.field}': /^${this.Parse(alphabet)}/i }`;
            //}
          }
          _sb += `]},`;
        });
        _sb += ` ] `;
      }
    }
    return _sb;
  }

  GetOrWithAndQuery(_sb: string, fields: string, val: string, alphabet: string) {
    if (fields.length > 0) {
      _sb += `'$or': [`;
      const fieldsArray = fields.split(',');
      fieldsArray.forEach((element) => {
        _sb += `{ '$and' : [`;
        if (val !== undefined && val !== null && val !== 'null') {
          _sb += `{ '${element}': /^${this.Parse(val)}/i }`;
          if (alphabet !== undefined && alphabet !== null && alphabet !== 'null' && alphabet !== '') {
            _sb += `,{ '${element}': /^${this.Parse(alphabet)}/i }`;
          }
        }
        _sb += `]},`;
      });
      _sb += ` ] `;
    }
    return _sb;
  }
  GetOrQuery(_sb: string, fields: string, val: string) {
    if (fields.length > 0) {
      _sb += `'$or': [`;
      const fieldsArray = fields.split(',');
      fieldsArray.forEach((element) => {
        if (val !== undefined && val !== null && val !== 'null') {
          _sb += `{'${element}': /${this.Parse(val)}/i },`;
        }
      });
      _sb += `]}`;
    }
    return _sb;
  }
  GetOrWithAndQueryOnSelectedColumns(_sb: string, fields: any, val: string, alphabet: string) {
    let fieldsArray = fields
      .filter((search: any) => search !== undefined && search.search !== undefined)
      .map((search: any) => ({ search: search.search, isChecked: search.isChecked }));
    if (fieldsArray.length > 0 && fieldsArray.map((c: any) => c.isChecked).includes(true)) {
      _sb += `'$or': [`;
      fieldsArray.forEach((element: any) => {
        if (element !== undefined && element.isChecked) {
          _sb += `{ '$and' : [`;
          if (val !== undefined && val !== null && val !== 'null') {
            _sb += `{ '${element.search}': /${this.Parse(val)}/i }`;
            if (alphabet !== undefined && alphabet !== null && alphabet !== 'null' && alphabet !== '') {
              _sb += `,{ '${element.search}': /^${this.Parse(alphabet)}/i },`;
            }
          }
          _sb += `]},`;
        }
      });
      _sb += ` ] `;
    }
    return _sb;
  }

  AppendNotContains(
    _sb: string,
    fieldName: string,
    val: string[],
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    let value = '';
    val.forEach((item) => {
      // value += "/.*" + this.Parse(item) + ".*/i,";
      value += ' /' + this.Parse(item) + '/i ,';
      if (item && !isNaN(Number(item))) {
        value += '' + item + ',';
      }
    });

    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { '$in': [${value}] }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { '$nin': [${value}] }${postfix},`;
    }

    return _sb;
  }

  AppendStartWith(
    _sb: string,
    fieldName: string,
    val: string[],
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    let value = '';
    val.forEach((item) => {
      // value += "/^" + this.Parse(item) + ".*/i,";
      value += `/^${this.Parse(item)}/i,`;
    });

    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}':  { '$nin' : [${value}] }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}':  { '$in' : [${value}] }${postfix},`;
    }

    return _sb;
  }

  AppendEndWith(
    _sb: string,
    fieldName: string,
    val: string[],
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    let value = '';
    val.forEach((item) => {
      // value += "/.*" + this.Parse(item) + "/i,";
      value += `/${this.Parse(item)}$/i,`;
    });

    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}':  { '$nin' : [${value}] }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}':  { '$in' : [${value}] }${postfix},`;
    }

    return _sb;
  }

  AppendGreaterThan(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not:{ $gt: ${val} } }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $gt: ${val} }${postfix},`;
    }

    return _sb;
  }

  AppendGreaterThanEqualTo(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not:{ $gte: ${val} } }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $gte: ${val} }${postfix},`;
    }

    return _sb;
  }

  AppendLessThan(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not:{ $lt: ${val} } }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $lt: ${val} }${postfix},`;
    }

    return _sb;
  }

  AppendLessThanEqualTo(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not: { $lte: ${val} } }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $lte: ${val} }${postfix},`;
    }

    return _sb;
  }

  AppendEqualTo(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not : { $eq: ${val} } }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $eq: ${val} }${postfix},`;
    }

    return _sb;
  }

  AppendGreaterThanDate(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    const dtFormat = moment(val).format('YYYY-MM-DDT00:00:00.000');

    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not:{ $gt: ISODate('${dtFormat}Z') } }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $gt: ISODate('${dtFormat}Z') }${postfix},`;
    }

    return _sb;
  }

  AppendGreaterThanEqualToDate(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    const dtFormat = moment(val).format('YYYY-MM-DDT00:00:00.000');
    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not:{ $gte: ISODate('${dtFormat}Z') } }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $gte: ISODate('${dtFormat}Z') }${postfix},`;
    }

    return _sb;
  }

  AppendLessThanDate(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    const dtFormat = moment(val).format('YYYY-MM-DDT00:00:00.000');
    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not:{ $lt: ISODate('${dtFormat}Z') } }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $lt: ISODate('${dtFormat}Z') }${postfix},`;
    }

    return _sb;
  }

  AppendLessThanEqualToDate(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    const dtFormat = moment(val).format('YYYY-MM-DDT00:00:00.000');
    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not:{ $lte: ISODate('${dtFormat}Z') } }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $lte: ISODate('${dtFormat}Z') }${postfix},`;
    }

    return _sb;
  }

  AppendEqualToDate(
    _sb: string,
    fieldName: string,
    val: string,
    logicalOperator: string,
    prefix: string = '',
    postfix: string = ''
  ) {
    const dtStart = moment(val).format('YYYY-MM-DDT00:00:00.000');
    const dtEnd = moment(val).format('YYYY-MM-DD');

    if (logicalOperator === logicalOperators[2]) {
      _sb += `'${prefix}${fieldName}': { $not:{ $gte: ISODate('${dtStart}Z'), $lte: ISODate('${dtEnd}T23:59:59.000Z')}  }${postfix},`;
    } else {
      _sb += `'${prefix}${fieldName}': { $gte: ISODate('${dtStart}Z'), $lte: ISODate('${dtEnd}T23:59:59.000Z')  }${postfix},`;
    }

    return _sb;
  }

  Parse(stringToParse: string): string {
    if (typeof stringToParse === 'string') {
      const specialCharacterArray = ['\\', '$', '=', '/', '#', '.', '<', '>', '?', ':', '(', ')', '*', '+'];
      //specialCharacterArray.forEach(item => {
      //if (stringToParse.includes(item)) {
      stringToParse = stringToParse.replace(/[!@$^&*()+=\-[\]\\'`;,./{}|":?~_]/g, '\\$&');
      //stringToParse.split(item).join(`\\\\${item}`);
      // stringToParse.replace(new RegExp(`\\${item}`, 'g'), `\\\\${item}`)
      //}
      //});
    }
    return stringToParse;
  }
}
